var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mia-ShopInfoItem" }, [
    _c(
      "a",
      {
        staticClass: "mia-ShopInfoItem-avatar",
        attrs: { href: _vm.item.ProfileUrl }
      },
      [_c("responsive-image", { attrs: { from: _vm.item.Avatar } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mia-ShopInfoItem-body" }, [
      _c(
        "a",
        { staticClass: "mia-HyperLink", attrs: { href: _vm.item.ProfileUrl } },
        [_vm._v("\n\t\t\t" + _vm._s(_vm.item.Name) + "\n\t\t")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mia-ShopInfoItem-score" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.NumberOfCustomers))]),
        _vm._v(" "),
        _c("span", {
          directives: [
            {
              name: "tr",
              rawName: "v-tr",
              value: "ShopCompetitionNumberCustomersPostfix",
              expression: "'ShopCompetitionNumberCustomersPostfix'"
            }
          ]
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mia-ShopInfoItem-iconRow" }, [
        _c(
          "a",
          { attrs: { href: _vm.item.ShopUrl } },
          [_c("inline-svg", { attrs: { src: _vm.shopLogo } })],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.item.HouseUrl } },
          [_c("inline-svg", { attrs: { src: _vm.houseLogo } })],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }